import React from "react";
import Header from "../components/Header";
import NavigationSideBar from "../components/NavigationSideBar";
import InnerBody from "../components/InnerBody";
import TitleBar from "../components/TitleBar";
import withAuthorization from "../firebase/withAuthorization";
import TabsPanel from "../components/TabsPanel";
import Table from "../components/Table";
import withAccount from "../utils/withAccount";
import TextInput from "../components/TextInput";
import HelpIcon from "../components/HelpIcon";

class PageSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: false };
  }

  render() {
    return (
      <div>
        <Header
          title="Einstellungen"
          showProjectsDropdown={false}
          showProfile={true}
        />
        <NavigationSideBar page="settings" />
        <InnerBody isLoading={this.state.isLoading}>
          <TabsPanel
            tabLabels={["Konto", "Branding", "Zahlung"]}
            tabContents={[
              this.renderTabAccount(),
              <TabBranding />,
              this.renderTabBilling(),
              this.renderTabAdvanced()
            ]}
          />
        </InnerBody>
      </div>
    );
  }

  renderTabAccount() {
    const { account } = this.props;
    return <p>{account.name}</p>;
  }

  renderTabBilling() {
    const { account } = this.props;
    return (
      <div>
        <p>
          Das Konto {account.name} verfügt über den Lizentyp: Testversion. Daher
          fallen Ihnen für die Nutzung dieser Software keine Kosten an.
        </p>
      </div>
    );
    /*
    return (
      <Table
        header={[
          {
            items: ["Datum", "Preis", "Bezahlt"]
          }
        ]}
        onItemSelected={(index, col) => {}}
        colSelectables={[]}
        data={[
          { items: ["31.7.2018", "59,99€", <i className="fas fa-check" />] },
          { items: ["30.6.2018", "59,99€", <i className="fas fa-check" />] }
        ]}
      >
        {null}
      </Table>
    );
    */
  }

  renderTabAdvanced() {
    return null;
  }
}

const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(withAccount(PageSettings));

class TabBranding extends React.Component {
  constructor(props) {
    super(props);

    const emailTemplates = require("../constants/email_templates");
    const emailTemplateApproval = emailTemplates.approval;

    this.state = {
      email_approval_topic: emailTemplateApproval.topic,
      email_approval_body: emailTemplateApproval.body
    };
  }

  render() {
    const { email_approval_topic, email_approval_body } = this.state;

    return (
      <div>
        <p>
          Freigabe E-Mail
          <HelpIcon text="Diese E-Mail wird einem Kunden geschickt, sobald ein Projekt fertiggestellt ist." />
        </p>
        <TextInput placeholder="Betreff" value={email_approval_topic} />
        <TextInput
          placeholder="Nachricht"
          value={email_approval_body}
          area
          noSpellcheck
        />
        <small>
          Variabeln: <i title="Der Vorname der Kontaktperson">%FIRST%, </i>
          <i title="Der Nachname der Kontaktperson">%LAST%, </i>
          <i title="Der Unternehmensname">%CLIENT%, </i>
          <i title="Der Projektname">%PROJECT%, </i>
          <i title="Der Link zum Viewer">%LINK%, </i>
          <i title="Ihr Teamname">%TEAM%</i>
        </small>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageSettings.js